import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { JCStatusesAdapter, JCStatesAdapter, ReportTypesAdapter } from './adapters';

export const JCStatuses = JCStatusesAdapter.getSelectors((state: RootState) => state.main.dictionaries.jcStatuses);
export const JCStates = JCStatesAdapter.getSelectors((state: RootState) => state.main.dictionaries.jcStates);
export const reportTypes = ReportTypesAdapter.getSelectors((state: RootState) => state.main.dictionaries.reportTypes);
export const notification = (state: RootState) => state.main.notification;

export const branches = (state: RootState) => state.main.dictionaries.branches;
export const companiesSelect = (state: RootState) => state.main.dictionaries.companies;
export const logoSelector = (state: RootState) => state.main.logo;
export const reportTypesSelector = createSelector(reportTypes.selectAll, (reportTypes) => reportTypes);
export const JCStatusesSelector = createSelector(JCStatuses.selectAll, (statuses) => statuses);
export const JCStatesSelector = createSelector(JCStates.selectAll, (state) => state);
export const branchSelector = createSelector(branches, (branches) => branches);
export const companiesSelector = createSelector(companiesSelect, (companies) => companies);
export const notificationSelector = createSelector(notification, (notification) => notification);
